import { differenceInMinutes } from 'date-fns';
import { ZonedDateTimeRangeDto } from '../../core/api/CorporateClient';
import { toZonedDateTime, ZonedDateTime } from '@ms-rewards/date-lib';
import { Option } from '@components/select';

export interface Time {
    hours: number;
    minutes: number;
    seconds: number;
    milliseconds: number;
}

export function getRangeLength(timeRange: ZonedDateTimeRangeDto) {
    const dateFrom = new Date(timeRange.from);
    const dateTo = new Date(timeRange.to);

    return differenceInMinutes(dateTo, dateFrom);
}

export function getTimeZones() {
    return Intl.supportedValuesOf('timeZone');
}

export const DEFAULT_TIME_ZONE = 'Europe/Berlin';

export function getEndDayOfNextMonthInDateFormat(
    time?: Time,
    timezone = DEFAULT_TIME_ZONE
): ZonedDateTime {
    const date = ZonedDateTime.now(timezone);
    const endDay = date.addMonths(1).endOf('month');

    if (time) {
        return endDay.setHour(time.hours).setMinute(time.minutes);
    }

    return endDay;
}

export function getStartDayOfNextMonthInDateFormat(
    time?: Time,
    timezone = DEFAULT_TIME_ZONE
): ZonedDateTime {
    const date = ZonedDateTime.now(timezone);
    const startDay = date.addMonths(1).startOf('month');
    if (time) {
        return startDay.setHour(time.hours).setMinute(time.minutes);
    }
    return startDay;
}

export function truncateDateToMidnight(val: ZonedDateTime) {
    return val.setHour(0).setMinute(0).setSecond(0).setMillisecond(0);
}

/**
 * Extracts IANA timezone from a ZonedDateTime string like:
 *  "2022-01-01T01:00:00.000+01:00[Europe/Berlin]"
 */

export function extractTimeZoneFromZonedString(
    input?: string
): string | undefined {
    if (!input) return undefined;
    const match = input.match(/\[(.+?)\]$/);
    return match?.[1];
}

export function getTimezoneOptions(): Option<string>[] {
    return getTimeZones().map((timezone) => ({
        label: timezone,
        value: timezone
    }));
}

export function generateDateRange(
    from: ZonedDateTime,
    to: ZonedDateTime,
    timezone: string
): ZonedDateTimeRangeDto {
    return {
        from: toZonedDateTime(from, timezone).toJSON(),
        to: toZonedDateTime(to, timezone).toJSON()
    };
}
